import { render, staticRenderFns } from "./projectPsuIndex.vue?vue&type=template&id=7ed6076a&"
import script from "./projectPsuIndex.vue?vue&type=script&lang=js&"
export * from "./projectPsuIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports